'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  // Settings
  var countryListUS = 'us,ca,il,vn,id,th,ph,ar,br,mx,tr,sa,ae';
  var countryListEU = 'ie,pl,at,bg,cz,dk,ee,ie,el,es,it,hr,cy,lv,lt,hu,mt,nl,at,pt,ro,si,sk,fi,se';
  var countryListAU = 'au,nz';
  var countryListFR = 'fr,be,lu,ch';
  var countryListDE = 'de';
  var currentStoreNameUS = 'United States';
  var currentStoreNameEU = 'Ireland & Mainland Europe';
  var currentStoreNameFR = 'France';
  var currentStoreNameAU = 'Australia';
  var currentStoreNameROW = 'UK & Rest of the World';
  var storeNameUS = 'United States';
  var storeNameEU = 'Ireland & Mainland Europe';
  var storeNameFR = 'France, Belgium, Luxembourg, Switzerland & Monaco';
  var storeNameAU = 'Australia';
  var storeNameROW = 'UK & Rest of the World';
  var storeUrlUS = 'https://www.abbottlyon.us';
  var storeUrlEU = 'https://www.abbottlyon.eu';
  var storeUrlFR = 'https://www.abbottlyon.fr';
  var storeUrlDE = 'https://www.abbottlyon.de';
  var storeUrlAU = 'https://au.abbottlyon.com';
  var storeUrlROW = 'https://www.abbottlyon.com';
  var flagEU = (0, _jquery2.default)('.sto-Switcher_Btn-go').data('flag-eu');
  var flagFR = (0, _jquery2.default)('.sto-Switcher_Btn-go').data('flag-fr');
  var flagUS = (0, _jquery2.default)('.sto-Switcher_Btn-go').data('flag-us');
  var flagAU = (0, _jquery2.default)('.sto-Switcher_Btn-go').data('flag-aus');
  var flagROW = (0, _jquery2.default)('.sto-Switcher_Btn-go').data('flag-row');

  var redirectUrl = '';

  // Gets current store country based on the URL
  function getThisCountry() {
    var storeCountry = window.location.hostname.split('.').slice(-1)[0];
    var storeCountrySubDomain = window.location.hostname.split('.')[0];
    if (storeCountry === 'us') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameUS);
      return 'us';
    } else if (storeCountry === 'eu' || storeCountry === 'ie') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameEU);
      return 'eu';
    } else if (storeCountry === 'fr') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameFR);
      return 'fr';
    } else if (storeCountrySubDomain === 'au') {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameAU);
      return 'au';
    } else {
      (0, _jquery2.default)('.currentLocationCountry').html(currentStoreNameROW);
      return 'global';
    }
  }

  // User wants to stay, drop a cookie so they don't see popup again
  document.querySelector('.sto-Switcher_Btn-stay').onclick = function () {
    var storeCountry = getThisCountry();
    _jsCookie2.default.set('stay-' + storeCountry, 'true', { expires: 3650 });

    document.querySelector('.sto-Switcher').classList.remove('sto-Switcher-open');
  };

  // User wants to go so send them to the alternative store
  document.querySelector('.sto-Switcher_Btn-go').onclick = function () {
    redirectUrl = redirectUrl + window.location.pathname + window.location.search;
    window.location = redirectUrl;
  };

  (0, _jquery2.default)(function () {
    var storeCountry = getThisCountry();

    // Only run if no cookie
    if (_jsCookie2.default.get('stay-' + storeCountry) === undefined && !Shopify.designMode) {
      // Look up country by IP Address
      _jquery2.default.getJSON('https://ipapi.co/json', function (data) {
        var userCountry = data.country.toLowerCase();
        storeCountry = getThisCountry();

        // console.log(data)
        // console.log(storeCountry)
        // console.log(`My country is: ${userCountry}`)
        // console.log(`The store country is: ${storeCountry}`)

        // EU
        if (storeCountry === 'eu' && countryListEU.indexOf(userCountry) < 0) {
          if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          } else if (countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlFR;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameFR);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameFR);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagFR);
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          }

          if (countryListDE.indexOf(userCountry) >= 0) {
            window.location.replace(storeUrlDE);
          } else {
            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          }
        }

        // US
        if (storeCountry === 'us' && countryListUS.indexOf(userCountry) < 0) {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          } else if (countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlFR;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameFR);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameFR);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagFR);
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          }

          if (countryListDE.indexOf(userCountry) >= 0) {
            window.location.replace(storeUrlDE);
          } else {
            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          }
        }

        // AU
        if (storeCountry === 'au' && countryListAU.indexOf(userCountry) < 0) {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          } else if (countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlFR;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameFR);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameFR);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagFR);
          } else if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          }

          if (countryListDE.indexOf(userCountry) >= 0) {
            window.location.replace(storeUrlDE);
          } else {
            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          }
        }

        // FR
        if (storeCountry === 'fr' && countryListFR.indexOf(userCountry) < 0) {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);
          } else if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);
          } else if (!countryListAU.indexOf(userCountry) >= 0 && !countryListUS.indexOf(userCountry) >= 0 && !countryListEU.indexOf(userCountry) >= 0 && !countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlROW;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameROW);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameROW);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagROW);
          } else {
            redirectUrl = storeUrlFR;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameFR);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagFR);
          }

          if (countryListDE.indexOf(userCountry) >= 0) {
            window.location.replace(storeUrlDE);
          } else {
            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          }
        }

        // UK & Rest of the World
        if (storeCountry === 'global') {
          if (countryListEU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlEU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameEU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameEU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagEU);

            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          } else if (countryListUS.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlUS;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameUS);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameUS);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagUS);

            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          } else if (countryListFR.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlFR;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameFR);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameFR);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagFR);

            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          } else if (countryListAU.indexOf(userCountry) >= 0) {
            redirectUrl = storeUrlAU;
            (0, _jquery2.default)('.locationOriginCountry').html(storeNameAU);
            (0, _jquery2.default)('.suggestedCountry').html(storeNameAU);
            (0, _jquery2.default)('#suggestedFlag').attr('src', flagAU);

            document.querySelector('.sto-Switcher-storeSwitcher').classList.add('sto-Switcher-open');
          } else if (countryListDE.indexOf(userCountry) >= 0) {
            window.location.replace(storeUrlDE);
          }
        }
      });
    }
  });
}